import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.364 7.768a.9.9 0 0 1 1.272 0l5.1 5.1a.9.9 0 1 1-1.272 1.273L12 9.677l-4.464 4.464a.9.9 0 1 1-1.272-1.273z"
    }, null, -1)
  ])))
}
export default { render: render }